
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comics",
      function () {
        return require("private-next-pages/comics/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comics"])
      });
    }
  